import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../activity/202409/exchange-reward-score/index.vue')
const Rank = () => import('../activity/202409/exchange-reward-score/Rank/Rank.vue')
const Record = () => import('../activity/202409/exchange-reward-score/RecordList.vue')

export const indexRoute: RouteConfig = {
  path: '/exchange-reward-score-202409',
  name: 'exchange_reward_score_202409',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const recordRoute: RouteConfig = {
  path: '/exchange-reward-score-202409-record',
  name: 'exchange_reward_score_202409_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export const rankRoute: RouteConfig = {
  path: '/exchange-reward-score-202409-rank',
  name: 'exchange_reward_score_202409_rank',
  component: Rank,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '积分兑换',
    ignoreLogin: true,
  },
}

export default [indexRoute, rankRoute, recordRoute]

export function navigateToExchangeReward2024(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
